import React, { useContext, useState, useEffect } from 'react';
import { Button, Container, List, Typography } from '@mui/material';
import Layout from '../../component/Layout';
import { UserProfile } from '../../contexts/UserContext';
import { SystemProfile } from '../../contexts/SystemContext';
import api from '../../connection/Axios';
import icoMailOn from '../../assets/icoMailOff.png';

const ListarUsuarios = () => {
  const [userData, setUserData] = useContext(UserProfile)
  const [systemData, setSystemData] = useContext(SystemProfile)
  const [techUsers, setTechUsers] = useState([])

  const headers = {
    headers: {
      "Content-Type": "application/json", "Access-Control-Allow-Origin": "*",
      "Authorization": `Bearer ${userData.token}`
    }};

  
    const users = {
      role: userData.role,
      companyId: userData.companyId
    }

    async function GetTechUsers() {
      api.post('auth/getUsers/', users, headers).then(response => {
        setTechUsers(response.data)
      }).catch(error => {
        setSystemData({...systemData, erro: error.message, errorType: 'warning'})
      })
    }
    
    useEffect(()=>{
      GetTechUsers()
    }, [])


    async function DeleteUser(username) {
      await api.post('auth/deleteUser', {username: username}, headers).then(response => {
        GetTechUsers()
      }).catch(error => {
        setSystemData({...systemData, erro: error.message, typeError: 'error'})
      })
    }

    async function ReSendCode(username) {
      await api.post('register/reSendCode', {username: username}, headers).then(response => {
        setSystemData({...systemData, message: 'Código de verificação reenviado com sucesso!', typeError: 'success'})
      }).catch(error => {
        setSystemData({...systemData, erro: error.message, typeError: 'error'})
      })
    }
 
    return (
      <>
          <Layout breadcrumb='Dashboard / Usuários / Listar Usuários' title='Listar Usuários'>
          <Typography>Usuários cadastradas no sistema EHS</Typography>
            <br />
            <div style={styles.list}>
            <div className='listItem' style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
                  <div style={({width: 220})}>
                    Nome
                  </div>
                  <div style={({width: 280})}>
                    Username
                  </div>
                  <div style={{width: 80}}>
                    Papel
                  </div>
                  <div style={{width: 50}}>
                    
                  </div>
                  <div style={{width: 100}}>

                  </div>
                </div>
              {techUsers?.map((comp, index)=>(
                <div className='listItem' style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
                  <div style={({width: 220})}>
                    {comp.name}
                  </div>
                  <div style={({width: 280})}>
                    {comp.username}
                  </div>
                  <div style={{width: 80}}>
                    {comp.role}
                  </div>
                  <Button style={{width: 100}} variant="outlined" disableElevation color="error" size='small' onClick={()=>{DeleteUser(comp.username)}}>Remover</Button>
                  <div style={{width: 50}}>
                    <Button  onClick={()=>{ReSendCode(comp.username)}}>
                      <img src={icoMailOn} width='20' />
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          </Layout>
      </>
    );
}

export default ListarUsuarios

const styles = {
  list: {
    backgroundColor: '#ffffff',
    borderRadius: 12,
    padding: 20
  }
}